<template>
    <div>
        <div class="flex-between">
            <div class="tabs">
                <a class="item" v-for="(item,index) in classTabs" :key="index" :class="{active: index == classActive}" @click="classTabChange(item,index)">{{item.className}}</a>
            </div>
            <div>
                <el-input placeholder="请输入考核名称" prefix-icon="el-icon-search" v-model="searchContent" clearable></el-input>  
            </div>
        </div>
        <el-table
            :cell-style="tableRowStyle"
            :header-cell-style="{background:'#328aff',color:'#FFFFFF'}"
            :data="tableData"
            stripe
            empty-text="目前无考核记录"
            :row-key="getRowKeys"
            @selection-change="handleSelectionChange"
            class="mat20"
        >
            <el-table-column type="selection" width="55" align="center" :reserve-selection="true"></el-table-column>
            <el-table-column prop="id" label="次序" width="120" align="center" type="index"></el-table-column>
            <el-table-column prop="className" label="班级" align="center"></el-table-column>
            <el-table-column prop="experimentalName" label="考核名称" align="center"></el-table-column>
            <el-table-column prop="score" label="得分" align="center"></el-table-column>
            <el-table-column prop="timeConsuming" label="耗时" align="center">
                <template slot-scope="scope">
                    {{scope.row.timeConsuming}}分
                </template>
            </el-table-column>
            <el-table-column prop="startTime" label="起始时间" align="center"></el-table-column>
            <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="toReport(scope.row)">实验成绩报告</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background :current-page="pageNo" layout="total, prev, pager, next" :total="totals" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pattern: Number(sessionStorage.getItem('pattern')),
            totals: 0,
            tableData: [],
            userId: this.$store.state.userId,
            pageNo: 1,
            pageSize: 10,
            classTabs: {
                classId: '',
                className: '全部'
            },
            classActive: 0,
            classId: '',
            searchContent: ''
        };
    },
    created() {
        this.getData();
        this.getClassData()
    },
    watch: {
        searchContent (val) {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => {
                this.getData()
            },500)
        }
    },
    methods: {
        tableRowStyle({ row, column, rowIndex, columnIndex }) {
            if (rowIndex % 2 === 0) {
                return 'background-color: #FFF';
            } else {
                return 'background-color: #F5F2FF';
            }
        },
        handleCurrentChange(val) {
            this.pageNo = val
            this.getData()
        },
        getData() {
            this.$post(this.api.fictitiousRecord, { 
                classId: this.classId,
                userId: this.userId,
                page: this.pageNo,
                size: this.pageSize,
                searchContent: this.core.encodeString(this.searchContent),
                source: 2,
                systemId: 3,
                pattern: this.pattern
             })
            .then(res => {
                let data = res.data
                this.tableData = data.list
                this.totals = data.totalCount
            })
            .catch(err => {
                console.log(err);
            });
        },
        exportData() {
            location.href = `${this.api.exportProjectRecord}?userId=${this.userId}`
        },
        toReport(row) {
            this.$router.push(`/showExperiment?id=${row.reportId}`)
        },
        getRowKeys(row){
            return row.reportId
        },
        handleSelectionChange(val) {
            this.$emit("handleSelect",val)
        },
        getClassData(){
            this.$get(`${this.api.mineClass}?userId=${this.userId}`).then(res => {
                res.list.unshift({...this.classTabs})
                this.classTabs = res.list
            }).catch(res => {});
        },
        classTabChange(item,index){
            this.classActive = index
            this.classId = item.classId
            this.getData()
        },
    }
};
</script>

<style lang="scss" scopted>
.mat20{
    margin-top: 20px;
} 
</style>